import { RPCDocs } from "../../../services/rpc.js";
import { NOTIFICATION_CATEGORY_ICONS, NOTIFICATION_CATEGORY_LABELS, NOTIFICATION_PRIORITY_VARIANTS, getResolveActionLabel } from "../constants.js";
import dayjs from "dayjs";
import { useState } from "react";
import { Button, Icon, Tag } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
// src/modules/Notifications/components/NotificationListItem.tsx
var Priority = RPCDocs.Notifications.FindMyNotifications.v1.Priority;
var PRIORITY_STRIPE_CLASSES = {
	caution: "border-l-caution",
	critical: "border-l-critical",
	info: "border-l-info",
	neutral: "border-l-neutral"
};
function NotificationListItem({ item, onOpen, onResolve }) {
	const [resolving, setResolving] = useState(false);
	const variant = NOTIFICATION_PRIORITY_VARIANTS[item.priority];
	const showPriorityTag = item.priority === Priority.High || item.priority === Priority.Critical;
	const handleResolve = async (evt) => {
		evt.stopPropagation();
		setResolving(true);
		try {
			await onResolve(item);
		} finally {
			setResolving(false);
		}
	};
	return /* @__PURE__ */ jsxs("div", {
		className: classnames("border-border gap-xs p-xs flex cursor-pointer border-b border-l-2 last:border-b-0", PRIORITY_STRIPE_CLASSES[variant], !item.read && "bg-main-faded"),
		onClick: () => onOpen(item),
		children: [
			/* @__PURE__ */ jsx(Icon, {
				Icon: NOTIFICATION_CATEGORY_ICONS[item.category],
				color: item.read ? void 0 : "strong",
				size: "sm"
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex min-w-0 grow flex-col",
				children: [
					/* @__PURE__ */ jsxs("div", {
						className: classnames("gap-xxs flex items-center text-sm", item.read ? "text-color" : "text-color-strong font-semibold"),
						children: [!item.read && /* @__PURE__ */ jsx("span", { className: "bg-main-light inline-block rounded-full p-1" }), /* @__PURE__ */ jsx("span", {
							className: "truncate",
							children: item.title
						})]
					}),
					item.body && /* @__PURE__ */ jsx("div", {
						className: "text-color-subtle line-clamp-2 text-xs",
						children: item.body
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "gap-xxs text-color-subtle mt-xxs flex items-center text-xs",
						children: [
							showPriorityTag && /* @__PURE__ */ jsx(Tag, {
								value: item.priority,
								variant
							}),
							/* @__PURE__ */ jsx("span", { children: NOTIFICATION_CATEGORY_LABELS[item.category] }),
							item.history?.createdAt && /* @__PURE__ */ jsx("span", { children: dayjs(item.history.createdAt).format("MMM D, HH:mm") })
						]
					})
				]
			}),
			item.requiresAction && /* @__PURE__ */ jsx("div", {
				className: "flex-none self-start",
				children: /* @__PURE__ */ jsx(Button, {
					loading: resolving,
					onClick: handleResolve,
					size: "xs",
					variant: "main",
					children: getResolveActionLabel(item.category)
				})
			})
		]
	});
}
export { NotificationListItem };

//# sourceMappingURL=NotificationListItem.js.map